import { TFunction } from 'i18next';
import { UtpCardStructure } from 'common/components';
import { WINDOWS_CDN_PATH } from '../../windows-constants';
import { Services } from './components';

export const getWindowsUtpCardList = (t: TFunction): UtpCardStructure<unknown>[] => [
  {
    elementName: t('utp-section.free-measurement.card-title'),
    header: {
      title: t('utp-section.free-measurement.card-title'),
      mobileTitle: t('utp-section.free-measurement.card-mobile-title') || '',
    },
    description: {
      text: t('utp-section.free-measurement.card-description'),
      mobileText: t('utp-section.free-measurement.card-mobile-description') || '',
    },
    image: {
      src: `${WINDOWS_CDN_PATH}/utp/free-measurement.png/free-measurement-01.png`,
      alt: t('utp-section.free-measurement.card-title'),
    },
    modalDescription: t('utp-section.free-measurement.modal-description') || '',
  },
  {
    elementName: t('utp-section.windows-accessories.card-title'),
    elementText: t('utp-section.windows-accessories.card-mobile-title') || '',
    header: {
      title: t('utp-section.windows-accessories.card-title'),
      mobileTitle: t('utp-section.windows-accessories.card-mobile-title') || '',
    },
    description: {
      text: t('utp-section.windows-accessories.card-description'),
    },
    image: {
      alt: t('utp-section.windows-accessories.card-title'),
      src: `${WINDOWS_CDN_PATH}/utp/windows-and-accessories.png/windows-and-accessories.png`,
    },
    modalDescription: t('utp-section.windows-accessories.modal-description') || '',
  },
  {
    elementName: t('utp-section.services.card-title'),
    header: {
      title: t('utp-section.services.card-title'),
    },
    description: {
      text: t('utp-section.services.card-description'),
      mobileText: t('utp-section.services.card-description') || '',
    },
    image: {
      alt: t('utp-section.services.card-title'),
      src: `${WINDOWS_CDN_PATH}/utp/services.png/services-01.png`,
    },
    modal: { content: Services },
  },
  {
    elementName: t('utp-section.quality-assurance.card-title'),
    header: {
      title: t('utp-section.quality-assurance.card-title'),
    },
    description: {
      text: t('utp-section.quality-assurance.card-description'),
    },
    image: {
      alt: t('utp-section.quality-assurance.card-title'),
      src: `${WINDOWS_CDN_PATH}/utp/quality-assurance.png/quality-assurance-01.png`,
    },
    modalDescription: t('utp-section.quality-assurance.modal-description') || '',
  },
];
